import { convert } from '@js-joda/core';

import { ChronicDisease } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { MedicalInformationPreview } from '../MedicalInformationModal/MedicalInformationModal';

export const mapChronicDiseaseToMedicalInformationPreview = (
   chronicDisease: ChronicDisease
): MedicalInformationPreview => ({
   type: 'CHRONIC_DISEASE',
   id: chronicDisease.id,
   createdBy: chronicDisease.createdBy,
   creationDate: chronicDisease.diagnosisCreationDate
      ? convert(chronicDisease.diagnosisCreationDate).toDate()
      : undefined,
   description: chronicDisease.description || '-',
   unsignedAttachmentCount: chronicDisease.unsignedAttachmentCount,
   attachments: chronicDisease.attachments,
   attachmentsSignedBy: chronicDisease.attachmentsSignedBy,
   medicalInformationRemoved: chronicDisease.medicalInformationRemoved,
});
